import React, { useState, useEffect } from 'react'
import { Route, Redirect } from 'react-router-dom'

import {useSelector} from 'react-redux'
import {ServerConfig} from 'config'
import axios from 'axios'
import { hasPermission } from 'utils/hasPermission';

// nodejs library to set properties for components
import PropTypes from 'prop-types'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Grid, Hidden, Container } from '@material-ui/core'
import { ListGroup, ListGroupItem } from 'reactstrap';
import { AppBar, Tabs, Tab } from '@material-ui/core';
import Box from "@material-ui/core/Box";

// components
import _, { get } from 'lodash'

import Page from 'components/Page/Page'

import PerMachine from './PerMachine.js'
import RTLedger from './RTLedger.js'
import TenantLedger from './TenantLedger.js'
import Invoices from './Invoices.js'
import Invoicing from './Invoicing.js'
import AccountingTenantLedger from './AccountingTenantLedger.js'

const useStyles = makeStyles((theme) => ({ }))

const AccountingPage = (props) => {
  const auth = useSelector(state => state.auth)
  const classes = useStyles()

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    console.log("New value set to "+newValue);
    setValue(newValue);
  };

  if(!auth.access_token){
    return <Redirect to="/login" />
  }

  const isAdmin = hasPermission(auth.permissions, ["Admin", "admin"]);
  const isAccounting = hasPermission(auth.permissions, ["Accounting", "admin"]);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div {...other}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }

  return (
    <Page title="Accounting">
        <Container maxWidth={false} >

        <AppBar position="static">
            {isAdmin &&
              <Tabs value={value} onChange={handleChange} aria-label="Sub-Menu">
                <Tab label="PerMachine" />
                <Tab label="RT Ledger" />
                <Tab label="Tenant Ledger" />
                <Tab label="Invoices" />
                <Tab label="Invoicing" />
              </Tabs>
            }

            {isAccounting &&
              <Tabs value={value} onChange={handleChange} aria-label="Sub-Menu">
                <Tab label="Invoices" />
                <Tab label="Invoicing" />
                <Tab label="Tenant Ledger" />
              </Tabs>
            }
        </AppBar>

        {isAdmin &&
          <>
            <TabPanel value={value} index={0}>
              <PerMachine />
            </TabPanel>

            <TabPanel value={value} index={1}>
              <RTLedger />
            </TabPanel>

            <TabPanel value={value} index={2}>
              <TenantLedger />
            </TabPanel>

            <TabPanel value={value} index={3}>
                <Invoices />
            </TabPanel>

            <TabPanel value={value} index={4}>
                <Invoicing />
            </TabPanel>
          </>
        }

        {isAccounting &&
          <>
            <TabPanel value={value} index={0}>
              <Invoices />
            </TabPanel>

            <TabPanel value={value} index={1}>
              <Invoicing />
            </TabPanel>

            <TabPanel value={value} index={2}>
            <AccountingTenantLedger />
            </TabPanel>
          </>
        }

        </Container>
    </Page>
  )
}

export default AccountingPage

AccountingPage.propTypes = {
  children: PropTypes.node
}
